// @flow strict

import React from 'react';
import { injectIntl } from 'react-intl';

// Styles
import { Wrapper, Header, Body, Footer } from '../ConfirmationModal/styles';

// Constants
import { MODAL_WIDTH } from 'utils/constants';

// Components
import { Title } from 'styles/common';
import { PrimaryButton, SecondaryButton, Modal } from 'components/_ReactUI_V1';

// Types
import type { IntlType } from 'types';

type Props = {
    intl: IntlType,
    onNavigateToNewVersion: () => void,
    onStayInOldVersion: () => void,
};

class CircuitVersionWarningModal extends React.PureComponent<Props> {
    render() {
        const { intl } = this.props;
        return (
            <Modal
                modalWidth={MODAL_WIDTH.LARGE}
                onHandleClose={this.props.onStayInOldVersion}
                style={{
                    wrapper: {
                        zIndex: '999999',
                    },
                }}
                disableClose
            >
                <Wrapper>
                    <Header>
                        <Title>
                            {intl.formatMessage({
                                id: 'components.CircuitVersionWarningModal.title',
                            })}
                        </Title>
                    </Header>
                    <Body>
                        <span>
                            {intl.formatMessage({
                                id: 'components.CircuitVersionWarningModal.description',
                            })}
                        </span>
                    </Body>
                    <Footer>
                        <SecondaryButton
                            text={intl.formatMessage({
                                id: 'components.CircuitVersionWarningModal.stayButton',
                            })}
                            onClick={this.props.onStayInOldVersion}
                        />
                        <PrimaryButton
                            text={intl.formatMessage({
                                id: 'components.CircuitVersionWarningModal.navigateButton',
                            })}
                            onClick={this.props.onNavigateToNewVersion}
                        />
                    </Footer>
                </Wrapper>
            </Modal>
        );
    }
}

export default injectIntl(CircuitVersionWarningModal);
